/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type LedgerParty = {
    id?: string;
    owner: LedgerParty.owner;
};
export namespace LedgerParty {
    export enum owner {
        SHOP = 'SHOP',
        REVENUE = 'REVENUE',
        THIRD_PARTY = 'THIRD_PARTY',
        CLEARING = 'CLEARING',
        BANKS = 'BANKS',
        FINANCIER = 'FINANCIER',
    }
}

